import type { ModerationState } from "@/redux/discussions/types";
import type {
  ModerationContentKind,
  ModerationDecisionSource,
  UserSanction,
} from "@/redux/moderation/types";

export const MODERATION_PATH = "/community/moderation";

export const QUEUE_BADGE_MAX = 99;

export const BAN_DURATIONS = [
  { key: "1d", days: 1 },
  { key: "7d", days: 7 },
  { key: "30d", days: 30 },
  { key: "90d", days: 90 },
  { key: "permanent", days: null },
] as const;

export const MODERATION_STATES = {
  PENDING_AI: "PENDING_AI",
  AI_REVIEWING: "AI_REVIEWING",
  PENDING_HUMAN: "PENDING_HUMAN",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  WITHDRAWN: "WITHDRAWN",
  SUPERSEDED: "SUPERSEDED",
} as const satisfies Record<ModerationState, ModerationState>;

export const MODERATION_CONTENT_KINDS = {
  DISCUSSION: "DISCUSSION",
  COMMENT: "COMMENT",
} as const satisfies Record<ModerationContentKind, ModerationContentKind>;

export const MODERATION_DECISION_SOURCES = {
  AI: "AI",
  HUMAN: "HUMAN",
  SYSTEM: "SYSTEM",
} as const satisfies Record<ModerationDecisionSource, ModerationDecisionSource>;

export const SANCTION_KINDS = {
  BAN: "BAN",
  WARNING: "WARNING",
} as const satisfies Record<UserSanction["kind"], UserSanction["kind"]>;

export const UNDER_REVIEW_STATES: ModerationState[] = [
  MODERATION_STATES.PENDING_AI,
  MODERATION_STATES.AI_REVIEWING,
  MODERATION_STATES.PENDING_HUMAN,
];
